import { object } from 'yup';

import { Space, SpacesSort, SpacesSortField } from '@playq/octopus2-apps';
import { SpaceID } from '@playq/octopus-common';

import { IQuery } from '/common/models';
import { fieldRequiredSchema } from '/helpers';
import { IRenderGenericTable } from '/shared/Table/context';

export interface ISpacesQuery extends IQuery<SpacesSortField, SpacesSort> {}

export const spaceEditSchema = object().shape({
  name: fieldRequiredSchema('Name'),
});

export interface ISpaceProps {
  space: Space;
  spacesQueryKey?: unknown[];
  renderGenericTable: IRenderGenericTable;
  onUpdateSpace: (space: Space) => void;
  onClose: VoidFunction;
  onCloseList: VoidFunction;
}

export interface ISpaceSelectProps {
  initialQuery?: ISpacesQuery;
  activeSpaceID?: SpaceID;

  renderGenericTable: IRenderGenericTable;
  onSelect: (space?: Space) => void;
  onClose: VoidFunction;
}

export interface ISpacesListProps {
  initialQuery?: ISpacesQuery;
  activeSpaceID?: SpaceID;

  renderGenericTable: IRenderGenericTable;
  onClose: VoidFunction;
  onEdit: (space: Space, spacesQueryKey: unknown[]) => void;
  onCreate: () => void;
  onSelect: (space?: Space) => void;
}

export interface IGlobalSpacesProps {
  onClose: VoidFunction;
}
